import React from "react";
import moment from "moment";

import AgentWarehouse from "assets/svgs/agent-warehouse";
import AssignUser from "assets/svgs/assigned_user";
import AutomaticOrder from "assets/svgs/automatic_order";
import BulkOrder from "assets/svgs/bulk_order";
import Delivered from "assets/svgs/delivered";
import Duplicate from "assets/svgs/duplicate";
import Flag from "assets/svgs/flag";
import ManualDelivered from "assets/svgs/manual_delivered";
import OrderPending from "assets/svgs/order_pending";
import Warehouse from "assets/svgs/warehouse";
import Called from "assets/svgs/called";
import Disabled from "assets/svgs/disabled";
import BookedCall from "assets/svgs/call_booked";
import Finished from "assets/svgs/finished";
import UnansweredCall from "assets/svgs/unanswered_call";
import SMSEmailSent from "assets/svgs/sms_email_sent";
import NotServiceable from "assets/svgs/not_serviceable";
import Shipped from "assets/svgs/shipped";
import Shipping from "assets/svgs/shipping";
import Comment from "assets/svgs/comment";
import OtherLogs from "assets/svgs/other_logs";
import RescheduleLog from "assets/svgs/reschedule_log";
import LinkSent from "assets/svgs/link_sent";
import { getFormattedDate } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import RefundDone from 'assets/svgs/refund_done';

function ActivityData({ activityLog }) {
  const formatDate = (inputDate) => {
    return <SoftBadge variant="info">{getFormattedDate(inputDate)}</SoftBadge>;
  };

  const renderCaseTitle = (title) => {
    return <div>{title}</div>;
  };

  const warningText = (name) => {
    return <span className="text-warning mx-1 fw-bold">{name}</span>;
  };

  const successText = (orderDisplayId) => {
    return <span className="text-success mx-1 fw-bold">{orderDisplayId}</span>;
  };
  const infoText = (info) => {
    return <span className="text-info mx-1 fw-bold">{info}</span>;
  };
  const secondaryText = (info) => {
    return <span className="text-secondary mx-1 fw-bold">{info}</span>;
  };

  function formatEventId(eventId) {
    const words = eventId.split("_");
    const formattedWords = words.map((word) => {
      const capitalizedWord =
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      return capitalizedWord;
    });
    const formattedEventId = formattedWords.join(" ");
    return formattedEventId;
  }

  const activityRow = "d-flex justify-content-between w-100 align-items-center";
  const renderActivityLog = () => {
    switch (activityLog.event_id) {
      case "BULK_ORDER":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <BulkOrder />
              <p className="m-0 ms-2">
                {warningText(activityLog.author_name)}
                marked
                <span className="text-success mx-1 fw-bold">
                  {activityLog.case.user.first_name}
                </span>
                order as
                {infoText("bulk order")}
                <span className="text-info mx-1 fw-bold">bulk order</span>
              </p>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "ODA_WAREHOUSE_CREATED":
        return (
          <div className={activityRow}>
            <div>
              <Warehouse />{" "}
              <span className="text-warning mx-1 fw-bold">
                {activityLog.author_name}
              </span>
              Created
              {infoText("bulk order")}
              <span className="text-info mx-1 fw-bold">ODA Warehouse</span>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "ADMIN_ORDER_ASSIGNMENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AssignUser />
              <p className="m-0 ms-2 text-black">
                {infoText("Order status updated: ")}
                {warningText(activityLog.author_name)}
                {infoText("assigned")}
                <span className="text-success mx-1 fw-bold">
                  {activityLog.case.user.first_name}
                </span>
                to{" "}
                <span className="text-warning mx-1 fw-bold">
                  {activityLog.meta.medical_rep.first_name}
                </span>
              </p>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "MEDICAL_REP_MARK_ORDER_SHIPPING":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Shipping />
              <p className="m-0 ms-2 text-black">
                {warningText(activityLog.author_name)}
                marked
                {successText(
                  `order ${activityLog?.meta?.order?.order_meta?.name}`
                )}
                {infoText("shipping")} for
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "MEDICAL_REP_ORDER_DOCTOR_ASSIGNMENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AssignUser />
              <p className="m-0 ms-2 text-black">
                {warningText(activityLog?.author_name)}
                {infoText("assigned")}
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.meta?.doctor?.first_name}
                </span>
                to{" "}
                <span className="text-warning mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>
              </p>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "ORDER_CAME_FOR_PROCESSING_AUTOMATICALLY":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AutomaticOrder />
              <p className="my-0 mx-2 text-black">
                Order
                {successText(activityLog?.meta?.orderDisplayId)}
                Came for
                {infoText("Automatic Processing")}
              </p>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "ORDER_DELIVERED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Delivered />
              <p className="my-0 mx-2 text-black">
                Order
                {successText(activityLog?.meta?.order?.order_display_id)}
                was
                {infoText("delivered")}
              </p>
            </div>
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "ORDER_DELIVERED_MANUAL":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <ManualDelivered />
              <div className="ms-2">
                <p className="m-0 text-black">
                  {warningText(activityLog?.author_name)}
                  marked order{" "}
                  {successText(activityLog?.meta?.order?.order_display_id)}
                  as
                  {infoText("delivered")}
                </p>
              </div>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_DIRECT_PENDING_PRESCRIPTION":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <OtherLogs />
              {secondaryText("Order Direct Pending Prescription Case")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_DIRECT_SHIPPING_PENDING":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <OrderPending />
              <p className="m-0 ms-2 text-black">
                Order {successText(activityLog?.meta?.orderDisplayId)}
                {infoText("shipping pending")}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_LINK_SENT":
        return (
          <div className={activityRow}>
            <div>
              <LinkSent />
              {renderCaseTitle("Order Link Sent Case")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_SHIPPED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Shipped />
              <p className="my-0 mx-2 text-black">
                {warningText(activityLog?.author_name)}
                {infoText("shipped")}
                Order
                {successText(activityLog?.case?.latest_order_display_id)}
                for
                <span className="text-success mx-1 fw-bold">
                  {activityLog.case.user.first_name}
                </span>
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_WAREHOUSE_CHANGED_VIA_AGENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AgentWarehouse />
              {secondaryText("Order Warehouse Changed via Agent Case")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_WAREHOUSE_CHANGED_VIA_SHOPIFY":
        return (
          <div className={activityRow}>
            {secondaryText("Order Warehouse Changed via Shopify Case")}
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ORDER_WAREHOUSE_CREATED_VIA_AGENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AgentWarehouse />
              {secondaryText("Order Warehouse Created via Agent Case")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "This is ODA Order, Flag-duplicateCustomer":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Flag />
              <p className="m-0 mx-2 d-flex align-items-center">
                This is ODA Order
                {successText(activityLog?.meta?.orderDisplayId)},
                <span className="mx-2">
                  <Duplicate />
                </span>
                {infoText("duplicate customer Case")}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "This is ODA Order, Flag-nonServicable":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Flag />
              <p className="m-0 mx-2 d-flex align-items-center">
                This is ODA Order
                {successText(activityLog?.meta?.orderDisplayId)},
                <span className="mx-1">
                  <NotServiceable />
                </span>
                {infoText("non servicable customer Case")}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );

      case "AUTO_SLOT_RESCHEDULED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <RescheduleLog />
              <p className="m-0 ms-2">
                {infoText("Slot auto reschedule")}
                for
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>{" "}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "DOCTOR_APPT_SLOT_BOOKED":
        return (
          <div className={activityRow}>
            {renderCaseTitle("DOCTOR_APPT_SLOT_BOOKED")}
            {formatDate(activityLog.updated_at)}
          </div>
        );
      case "SLOT_BOOKED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <BookedCall />
              <p className="ms-2 m-0">
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>
                {infoText("booked a call")} for
                {secondaryText(getFormattedDate(activityLog?.meta?.slot_time))}
               {activityLog?.meta?.assignment?<span className="text-info fw-bold">and Assigned to <span className="text-success"> {activityLog?.meta?.assignment}</span> </span>:null}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );

      case "SLOT_BOOKING_DISABLED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Disabled />
              <p className="m-0 ms-2 d-flex">
                Slot booking of{" "}
                {secondaryText(
                  moment(activityLog?.meta?.slotTime).format("DD MMM, h:mm a")
                )}{" "}
                is {infoText("disabled")}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );

      case "CUSTOMER_ANSWERED_ENGAGEMENT_FEEDBACK":
        return (
          <div className={activityRow}>
            <div>
              <OtherLogs />
              {secondaryText(
                formatEventId("CUSTOMER_ANSWERED_ENGAGEMENT_FEEDBACK")
              )}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ENGAGEMENT_UNANSWERED":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <UnansweredCall />
              <p className="m-0 ms-2">
                {warningText(activityLog?.author_name)}
                marked the engagement
                {infoText(`${activityLog?.meta?.engagement?.tag} as unanswered`)}
                for
                {successText(activityLog?.case?.user?.first_name)}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "KNOWLARITY_CALL":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Called />
              <p className="m-0 ms-1">
                {warningText(activityLog?.author_name)}
                {infoText("called")}
                {activityLog.meta.note ? (
                  <span>
                    {warningText(activityLog?.meta?.lead?.first_name)}
                    {infoText("order number ")}
                    {successText(activityLog?.case?.latest_order_display_id)}
                  </span>
                ) : (
                  successText(activityLog?.meta?.lead?.first_name)
                )}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "MEDICAL_REP_FINISHED_ENGAGEMENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Finished />
              <p className="m-0 ms-2 text-black">
                {warningText(activityLog?.meta?.medical_rep?.first_name)}
                finished
                {infoText(activityLog?.meta?.engagement?.is_slot_booked ? activityLog?.meta?.engagement.tag + ' + ' + 'Slot Booking' : activityLog?.meta?.engagement.tag)}
                for
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "TEMPORARY_ENGAGEMENT_ASSIGNMENT":
        return (
          <div className={activityRow}>
            <div>
              <div className="d-flex">
                <AssignUser />
                <p className="m-0 ms-2">
                  {warningText(activityLog?.author_name)}
                  {infoText("assigned")}
                  {warningText(`${activityLog?.meta?.owner?.first_name}'s`)}
                  engagement{infoText(activityLog?.meta?.engagement?.tag)}to
                  {warningText(activityLog?.meta?.assignment?.first_name)}
                </p>
              </div>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "CONCERN_CALL_CREATED":
        return (
          <div className={activityRow}>
            {renderCaseTitle("CONCERN_CALL_CREATED")}
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "CONCERN_CALL_UPDATED_ATTEMPTS_1":
        return (
          <div className={activityRow}>
            {renderCaseTitle("CONCERN_CALL_UPDATED_ATTEMPTS_1")}
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "PRESCRIPTION_CALL_CREATED":
        return (
          <div className={activityRow}>
            {renderCaseTitle("PRESCRIPTION_CALL_CREATED")}
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "PRESCRIPTION_CALL_UPDATED_ATTEMPTS_1":
        return (
          <div className={activityRow}>
            {renderCaseTitle("PRESCRIPTION_CALL_UPDATED_ATTEMPTS_1")}
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "UNANSWERED_CONSULT_CALL":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <SMSEmailSent />
              <p className="m-0 ms-2">
                {warningText(activityLog?.meta?.medical_rep?.first_name)}
                {infoText("sent")}
                <span className="mx-1">
                  <UnansweredCall />
                </span>
                {infoText("unanswered call SMS & Email ")}
                to
                {successText(activityLog?.meta?.customer?.first_name)}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "prescription_call_event":
        return (
          <div className={activityRow}>
            <div>
              <OtherLogs />
              {secondaryText("Prescription call event")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "engagement_call_event":
        return (
          <div className={activityRow}>
            <div>
              <OtherLogs />
              {secondaryText("Engagement call event")}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "CASE_COMMENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <Comment />
              <p className="m-0 ms-2">
                {warningText(activityLog?.author_name)}
                {infoText("commented")}
                <span className="mx-2 fst-italic">
                  {activityLog?.meta?.comment?.comment_text}
                </span>
                on
                {successText(activityLog?.case?.user.first_name)}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case "ADMIN_LEAD_ASSIGNMENT":
        return (
          <div className={activityRow}>
            <div className="d-flex">
              <AssignUser />
              <p className="m-0 ms-2">
                {warningText(activityLog.author_name)}
                {infoText("assigned")}
                <span className="text-success mx-1 fw-bold">
                  {activityLog?.case?.user?.first_name}
                </span>
                to
                {warningText(activityLog?.meta?.sales_rep?.first_name)}
              </p>
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
      case 'REFUND_DONE': return (
        <div className={activityRow}>
          <div>
            <RefundDone />
            {secondaryText(formatEventId(activityLog?.event_id))}
            {activityLog?.author_name && (
              <span className="text-secondary fw-bold"> by </span>
            )}
            {activityLog?.author_name && warningText(activityLog?.author_name)}
          </div>
          {formatDate(activityLog?.updated_at)}
        </div>
      );
      default:
        return (
          <div className={activityRow}>
            <div>
              <OtherLogs />
              {secondaryText(formatEventId(activityLog?.event_id))}
              {activityLog?.author_name && (
                <span className="text-secondary fw-bold">done by</span>
              )}
              {activityLog?.author_name && warningText(activityLog?.author_name)}
            </div>
            {formatDate(activityLog?.updated_at)}
          </div>
        );
    }
  };

  return <>{renderActivityLog()}</>;
}

export default ActivityData;
